import { Component, ChangeDetectionStrategy, ChangeDetectorRef, Input, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';
import * as _ from 'lodash';
import { PFieldAbstractComponent } from '../p-field-abstract';
import { ButtonTypeEnum } from '@panaya/ui/p-button';

@Component({
    selector: 'p-field-file',
    template: `
        <p-field
            [isMandatory]="isMandatory"
            [label]="label"
            [labelTooltip]="labelTooltip"
            [isReadOnly]="isReadOnly"
            [customClasses]="customClasses"
        >
            <div slot="readMode">
                <input readonly type="text" class="p-input" [value]="value?.name" />
            </div>
            <div slot="editMode" fxFlex fxLayout="start center" fxLayoutGap="10px">
                <mat-form-field
                    class="p-input-text p-input-file"
                    appearance="fill"
                    [class.mat-mdc-form-field-invalid]="invalid"
                    floatLabel="always"
                >
                    <p-icon *ngIf="!value" matPrefix name="paperclip" size="sm" (click)="openFileInput(fileInput)"></p-icon>

                    <input
                        matInput
                        [attr.automation-id]="'p-field-file_' + label"
                        readonly
                        type="text"
                        class="p-input-text-input"
                        (click)="openFileInput(fileInput)"
                        [placeholder]="'Actions.attach' | translate"
                        [value]="value?.name"
                        [matTooltip]="value?.name || ''"
                        matTooltipPosition="above"
                    />
                    <p-button
                        *ngIf="value"
                        matSuffix
                        ariaLabel="Attach File"
                        [buttonType]="buttonType"
                        iconBefore="paperclip"
                        iconBeforeSize="sm"
                        (buttonClicked)="openFileInput(fileInput)"
                    >
                    </p-button>
                </mat-form-field>
                <div class="error-div">
                    <mat-error *ngIf="invalid" class="error-message">
                        {{ errorMessage }}
                    </mat-error>
                </div>
            </div>
        </p-field>

        <input #fileInput [accept]="accepts" class="p-field--file" type="file" name="identifier" (change)="changeValue($event)" />
    `,
    styleUrls: ['./p-field-file.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: 'pFieldFile'
})
export class PFieldFileComponent extends PFieldAbstractComponent<File> {
    buttonType = ButtonTypeEnum.IsIcon;

    @Input() label?: string;
    @Input() isMandatory = false;
    @Input() allowedFileTypes: string[] = [];
    @Input() textCustomClass?: string;
    @Input() isInEditMode = true;
    @Input() customClasses?: string;
    @Input() errorMessage?: string;

    identifier = _.uniqueId('pFieldFile_');

    get accepts(): string {
        return this.allowedFileTypes.join(',');
    }

    constructor(@Self() @Optional() public control: NgControl, cd: ChangeDetectorRef) {
        super(cd);
        if (this.control) {
            this.control.valueAccessor = this;
        }
    }

    public get invalid(): boolean {
        return this.control && this.control.errors ? !this.control.errors['valid'] : false;
    }

    changeValue(ev: any) {
        this.markAsTouched();

        if (!this.isReadOnly) {
            if (ev.target.files.length > 0) {
                const file = ev.target.files[0];

                this.value = file;
                this._onChange(this.value);

                this.cd.detectChanges();
            }
        }
    }

    openFileInput(fileInput: HTMLInputElement) {
        fileInput.click();
    }
}
